module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_4.521a5165.png";